module.exports = __webpack_public_path__ + "img/other-1.359fe7eb.png";